export function storeTokens(data) {
    const refreshToken = data['refresh'];
    const accessToken = data['access'];
    if (refreshToken && accessToken) {
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem("access", accessToken);
    }
}